import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import CancelIcon from "@mui/icons-material/Cancel";
// import { useState } from "react";
import * as Yup from "yup";
import { makeEncryptedApiCall } from "../../utils/encryptionUtils";
import { toast } from "react-toastify";

const InviteSuperUser = ({
  isSelectedRowId,
  setIsTableRowClick,
  setIsDrawerOpen,
  onInviteSuccess
}: any) => {
  console.log(isSelectedRowId, "isSelectedRowId");
  // const [formData] = useState({
  //   name: "",
  //   email: "",
  // });
  // console.log("Form Data:", formData);

  const validation_schema = Yup.object().shape({
    firstname: Yup.string().required("First name is required"),
    lastname: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    contact: Yup.string()
      .matches(/^\d{10}$/, "Contact must be 10 digits")
      .required("Contact is required"),
  });

  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      contact: "",
      permission: "read_only", // default selection
    },
    validationSchema: validation_schema,
    onSubmit: async (values) => {
      const payload = {
        first_name: (values.firstname || "").trim(),
        last_name: (values.lastname || "").trim(),
        email: (values.email || "").trim(),
        phone_number: (values.contact || "").trim(),
        role: (values.permission || "").trim(), // already mapped for API
      };

       try {
        await makeEncryptedApiCall("/authentication/sa-invite-user", payload);
        if (typeof onInviteSuccess === 'function') {
          onInviteSuccess();
        } else if (setIsDrawerOpen) {
          setIsDrawerOpen(false);
        }
        toast.success("Super User invitation sent successfully");
      } catch (error: any) {
        toast.error(
          error?.response?.data?.message ||
            error?.message ||
            "Failed to send invitation"
        );
      }
    },
  });


  const roleMap = {
    read_only: "read_only", // View Organisations
    invite_only: "invite_only", // Invite Organizations
    invite_and_modify: "invite_and_modify", // Modify Licenses
  };

  const options = [
    { value: "read_only", label: "View Organizations" },
    { value: "invite_only", label: "Invite Organization" },
    { value: "invite_and_modify", label: "Modify Licenses" },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="body2" sx={{fontSize:"16px",fontWeight:"bold",p:2}}>Invite Super User</Typography>
        
        <IconButton onClick={() => setIsDrawerOpen(false)}>
          <CancelIcon sx={{ color: "#A6A5B6" }} />
        </IconButton>
      </div>
      <Divider  />
      <div style={{ padding: 20 }}>
        <form onSubmit={formik.handleSubmit} style={{ flexGrow: 1 }}>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              sx={{ mt: 2 }}
              id="First Name"
              label="First Name"
              variant="outlined"
              required
              fullWidth
              name="firstname"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.firstname}
              error={
                formik.touched.firstname && Boolean(formik.errors.firstname)
              }
              helperText={formik.touched.firstname && formik.errors.firstname}
              inputProps={{ maxLength: 64 }}
            />
            <TextField
              sx={{ mt: 2 }}
              id="Last Name"
              label="Last Name"
              variant="outlined"
              required
              fullWidth
              name="lastname"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.lastname}
              error={formik.touched.lastname && Boolean(formik.errors.lastname)}
              helperText={formik.touched.lastname && formik.errors.lastname}
              inputProps={{ maxLength: 64 }}
            />
          </Box>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              sx={{ width: "49%" }}
              id="email"
              label="Email"
              variant="outlined"
              required
              fullWidth
              name="email"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              helperText={formik.touched.email && formik.errors.email}
              error={formik.touched.email && Boolean(formik.errors.email)}
              inputProps={{ maxLength: 64 }}
            />
            <TextField
              sx={{ width: "49%" }}
              id="contact"
              label="Phone Number"
              variant="outlined"
              required
              fullWidth
              name="contact"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                formik.setFieldValue("contact", value);
              }}
              onBlur={formik.handleBlur}
              helperText={formik.touched.contact && formik.errors.contact}
              error={formik.touched.contact && Boolean(formik.errors.contact)}
              value={formik.values.contact}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 10, // for example, 10 digits max
              }}
            />
          </Box>
          <Typography variant="body2" fontWeight="bold" marginTop={2}>
            Permission
          </Typography>
          <Box display="flex" alignItems="center" gap={2}>
      {options.map((option) => {
  const isChecked =
    option.value === "read_only" ||
    (option.value === "invite_only" &&
      (formik.values.permission === "invite_only" ||
        formik.values.permission === "invite_and_modify")) ||
    (option.value === "invite_and_modify" &&
      formik.values.permission === "invite_and_modify");

  return (
    <FormControlLabel
      key={option.value}
      control={
        <Checkbox
          checked={isChecked}
          disabled={option.value === "read_only"} // Always checked
          onChange={() => {
            const current = formik.values.permission;

            if (option.value === "invite_and_modify") {
              if (isChecked) {
                // If Invite Organizations is already selected, keep it
                formik.setFieldValue(
                  "permission",
                  current === "invite_and_modify" && current !== "invite_only"
                    ? "invite_only"
                    : current
                );
              } else {
                // Turn on modify
                formik.setFieldValue("permission", "invite_and_modify");
              }
            } else if (option.value === "invite_only") {
              formik.setFieldValue(
                "permission",
                isChecked ? "read_only" : "invite_only"
              );
            }
          }}
        />
      }
      label={option.label}
    />
  );
})}


          </Box>
          <Box mt={3} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="small"
              sx={{
                minWidth: 100,
                minHeight: 35,
                position: "fixed",
                right: 32,
                bottom: 32,
                zIndex: 10,
              }}
              disabled={!(formik.isValid && formik.dirty)}
            >
              Invite
            </Button>
          </Box>
        </form>
      </div>
    </div>
  );
};

export default InviteSuperUser;
